import RouteNames from '../../../../../../app/router/_internals/RouteNames.enum';

export default Object.freeze({
	GENERAL: `${RouteNames.IMPORT_CSV}-general`,
	SETTINGS: `${RouteNames.IMPORT_CSV}-settings`,
	PERMISSIONS: `${RouteNames.IMPORT_CSV}-permissions`,
});
